import { MatchList } from 'ui/components/buyer/patterns/MatchList/MatchList';

/**
 * 買い手マッチング一覧
 */
export const BuyerMatchList: React.FC = () => {
    return <MatchList />;
};
